export enum PageCodeType {
    ADD_OR_COPY = '_U',
    REMOVE = '_D',
    EDIT = '_U',
    LIST = '_L',
    FILTER = '_F'
}
